import React from 'react'

import clsx from 'clsx'

import Image from 'next/image'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'

import img from './img.png'

import s from './AboutUsBlock.module.scss'

export type AboutUsBlockProps = {}

export const AboutUsBlock: React.FC<AboutUsBlockProps> = () => {
  return (
    <section className={s.AboutUsBlock}>
      <div className={s.AboutUsBlock__block}>
        <Typography
          variant={EnumTypographyVariants.H1}
          text="About us"
          className={s.AboutUsBlock__title}
        />

        <Typography
          variant={EnumTypographyVariants.H6}
          as="p"
          text="Insquad is a Talent Cloud platform to hire senior startup developers globally. We save our clients about 50 hours on each hire: Interview tomorrow, hire in two weeks. How do we assess whether the developer is startup-ready?
          Our 3-hours long vetting process includes not only hard skills tests and coding challenges, but also specifically developed soft-skills assessment and deep interview. We check if talent is prepared to work in a fast-paced environment, can motivate themselves, has good communication skills, and, most importantly, is passionate about working for a startup, not a big brand."
        />
      </div>

      <div className={clsx(s.AboutUsBlock__block, s.AboutUsBlock__img)}>
        <Image src={img.src} layout="fill" alt="" unoptimized />
      </div>
    </section>
  )
}
